import { useEffect } from 'react';
import { useBrand } from '../hooks/useBrand';
import { CSS_VARIABLES } from '../config/brands';

export function ThemeProvider({ children }) {
  const brand = useBrand();

  useEffect(() => {
    const root = document.documentElement;

    Object.entries(CSS_VARIABLES).forEach(([cssVar, colorKey]) => {
      let value;

      if (colorKey === 'font') {
        value = brand.font;
      } else {
        value = brand.colors[colorKey];
      }

      if (value) {
        root.style.setProperty(cssVar, value);
      }
    });

    const body = document.body;
    body.classList.remove('brand-claims1', 'brand-ycm', 'brand-mlm');
    const brandClass = `brand-${brand.id.toLowerCase()}`;
    body.classList.add(brandClass);
  }, [brand]);

  return children;
}
